import React from 'react';
import Heading2 from '@Components/heading_2/view';
import Heading3 from '@Components/heading_3/view';

import s from '../styles/DetailContent.module.css';

const Knowledge11 = () => {
    return (
        <div className={s.wrapper}>
            <section className={s.section}>
                <Heading2 title='ゴルフ会員権の税務上の扱いを解説' fontWeight={700} />
                <p>
                    ゴルフ会員権にかかる入会金と年会費では、それぞれ勘定科目が異なるため、注意が必要です。
                    <br />
                    ゴルフ会員権とは何かという基礎知識を踏まえた上で、税務上の扱いについてご紹介します。
                </p>

                <Heading3 title='入会金（名義書換料）' />
                <p>
                    ゴルフ場の会員に法人として入会している場合は、経費ではなく資産として計上します。
                    <br />
                    特定の役員・使用人が、法人業務に関連がない目的でゴルフ会員権を利用している場合は、その個人に対する給与として扱います。
                    <br />
                    また、法人に属する人物が個人会員として入会している場合も基本的に給与として計上します。
                    <br />
                    ただし、対象のゴルフ場に法人会員制度がなく、やむを得ず個人会員として入会、かつ業務上必要であり法人が負担するべきであると判断される時は、資産としての計上が可能です。
                </p>

                <Heading3 title='年会費' />
                <p>
                    ゴルフ会員権の年会費は、入会金の扱いによって処理が異なります。
                    <br />
                    入会金を資産計上している場合は交際費、給与計上している場合は特定の役員・使用人に対する給与として扱われます。
                    <br />
                    勘定科目の判定方法や具体的な経費算入の可否については
                    <a href='/knowledge/32'>年会費の勘定科目・経費算入の可否</a>
                    で詳しくご紹介しています。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='ゴルフ会員権の年会費が払えない際に起きることや対処法について' fontWeight={700} />
                <p>
                    万が一、ゴルフ会員権の年会費が払えなくなった場合や、プレーしなくなったので年会費を払いたくないという場合にはどう対処すればいいのでしょうか。
                    <br />
                    年会費が払えなくなると起こることや、対処法を知っておきましょう。
                </p>

                <Heading3 title='年会費が払えない際に起きることとは' />
                <p>
                    年会費が支払えなくなるとゴルフ場からの督促がはじまり、最終的には除名処分を受ける場合もあります。
                    <br />
                    また、ゴルフ会員権の売却にも影響が及ぶ可能性が高いです。
                    <br />
                    <br />
                    <strong>
                        <u>督促状が届く</u>
                    </strong>
                    <br />
                    年会費は、一般的に年初に請求される形となりますが、支払いを放置していると督促状が送られてきます。
                    <br />
                    支払いがされるまで、継続的に送付されることになるでしょう。
                    <br />
                    <br />
                    <strong>
                        <u>未収の債権として扱われる</u>
                    </strong>
                    <br />
                    その後も支払いがなされない場合は、未収の債権として蓄積されていきます。
                    <br />
                    長期間に及ぶと、訴訟を起こされる可能性もあります。
                    <br />
                    <br />
                    <strong>
                        <u>ゴルフ場により数年で除名になる</u>
                    </strong>
                    <br />
                    そのまま数年間滞納が続き、未納金がゴルフ会員権の購入時に納めた預託金を上回った場合は、除名処分になる場合もあります。
                    <br />
                    除名処分となった場合は、預託金での清算、差額の一括支払いが求められることがあります。
                    <br />
                    <br />
                    <strong>
                        <u>未納があると売却（譲渡）ができない</u>
                    </strong>
                    <br />
                    いざ会員権を売却しようと思っても、未納金がある状態では売却ができない可能性もあります。
                    <br />
                    未納金が売却代金を上回る場合、差額を現金で用意する必要があるためです。
                </p>

                <Heading3 title='年会費がどうしても支払えない時の対処法' />
                <p>
                    どうしても年会費の支払いが難しい場合は、以下の対処を検討してみましょう。
                    <br />
                    <br />
                    <strong>
                        <u>ゴルフ会員権を売却</u>
                    </strong>
                    <br />
                    当面、支払える見込みがない場合は、ゴルフ会員権を売却することを検討しましょう。
                    <br />
                    未納金をリセットすることはできませんが、すでにプレーしなくなったのであれば、年会費を余計に払い続けることになりますので、早めの売却がおすすめです。
                    <br />
                    ただし、先述したように、売却には完納が条件というケースも存在するため、あらかじめ確認する必要があります。
                    <br />
                    <br />
                    <strong>
                        <u>ゴルフ場の休会制度を利用する</u>
                    </strong>
                    <br />
                    ゴルフ場によっては、休会制度が設けられています。
                    <br />
                    一時的に支払いが困難、プレーしないという場合は、休会を利用するのも一つの手です。休会が認められれば年会費は発生しません。
                    <br />
                    しかし、休会には条件が定められているケースが多く、必ずしも認められる訳ではありません。
                    <br />
                    また、休会中にも年会費が発生するケースもあるため、休会が最適な選択か検討する必要があります。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='プレーしなくなった時ゴルフ会員権はどうすればよいのか' fontWeight={700} />
                <p>
                    ゴルフ会員権を持っているものの、最近プレーしなくなってしまったという方もいるかと思います。
                    <br />
                    ゴルフ会員権を持っている限り、プレーの有無にかかわらず年会費は発生します。
                    <br />
                    その場合は、早めに会員権を売却することをおすすめします。
                    <br />
                    プレー予定がない状況で会員権を持ち続けることは、不要な出費を生み出すだけです。どうしても会員権を維持したい理由がなければ、早期の売却がおすすめです。
                    <br />
                    一方で、プレー希望はあるものの、海外出張や病気療養で一時的に不可能という場合は、先述したように休会という選択肢もあります。
                </p>
            </section>

            <section className={s.section}>
                <Heading2 title='ゴルフ会員権を売却するならお早めに' fontWeight={700} />
                <p>
                    ゴルフ会員権の年会費は、決して安い金額ではありません。具体的な金額の目安や入会時にかかる総額については
                    <a href='/knowledge/13'>ゴルフ会員権を安く買う方法は？ご入会にかかる総額について</a>
                    でご紹介していますので、あわせてご確認ください。
                    <br />
                    支払いが見込めない場合は、早期の段階で売却や休会などの対応を検討する必要があります。
                    <br />
                    放置していても良い結果は生みませんので、適切な判断をおこないましょう。
                    <br />
                    そもそもゴルフ会員権とは何かという基礎知識は<a href='/knowledge/8'>こちら</a>をご覧ください。
                </p>
            </section>
        </div>
    );
};

export default Knowledge11;
